import * as React from "react";
import { useDashboard } from "./DashboardContext.js";

interface FeatureFlagContextValue { aiEnabled: boolean; refreshFlags: () => void; }

const FeatureFlagContext = React.createContext<FeatureFlagContextValue>({ aiEnabled: true, refreshFlags: () => {} });

export const useFeatureFlags = () => React.useContext(FeatureFlagContext);

export function FeatureFlagProvider({ children }: { children: React.ReactNode }) {
  const { data, refresh } = useDashboard();
  const aiEnabled = data?.settings?.aiEnabled ?? true;

  return <FeatureFlagContext.Provider value={{ aiEnabled, refreshFlags: refresh }}>{children}</FeatureFlagContext.Provider>;
}
